module.exports = __webpack_public_path__ + "img/sub_error.afd400ba.svg";